import React from 'react';

const VintageButton = ({
  onClick,
  children,
  className = '',
  style = {},
  visible = true
}) => {
  return (
    <>
      <div
        style={{
          position: 'relative',
          marginTop: '2rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          opacity: visible ? 1 : 0,
          transform: visible ? 'scale(1) translateY(0px)' : 'scale(0.8) translateY(20px)',
          transition: 'all 0.8s cubic-bezier(0.16, 1, 0.3, 1)'
        }}
      >
        <button
          className={`animated-button vintage-button ${className}`}
          onClick={onClick}
          style={{
            fontFamily: '"Pixelify Sans", system-ui',
            fontOpticalSizing: 'auto',
            fontWeight: 400,
            fontStyle: 'normal',
            background: 'none',
            border: '2px solid white',
            padding: '8px 20px',
            boxShadow: '4px 4px white',
            transitionProperty: 'transform, box-shadow, outline-offset',
            transition: '100ms ease-in',
            cursor: 'pointer',
            color: 'white',
            fontSize: '1rem',
            letterSpacing: '0.05em',
            position: 'relative',
            zIndex: 1,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            textAlign: 'center',
            lineHeight: '1.2',
            ...style
          }}
        >
          <span>
            {children}
          </span>
        </button>
      </div>

      {/* CSS for vintage button styles */}
      <style>{`
        .vintage-button:hover {
          cursor: url('/icons/pointer.svg') 10 0, pointer;
        }
        
        .vintage-button:focus-visible {
          outline-offset: 12px;
          outline: 2px dotted white;
        }
        
        .vintage-button:active {
          box-shadow: 2px 2px white !important;
          transform: scale(0.99) !important;
        }
      `}</style>
    </>
  );
};

export default VintageButton;
